var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40869 14.7141C9.40869 14.7141 9.45097 14.7563 9.47115 14.7738C9.49134 14.7914 9.51344 14.8161 9.53554 14.8408C13.455 18.7471 18.8145 20.2253 19.2937 18.5748L19.8324 16.2504C19.8732 16.0559 19.8014 15.8457 19.6395 15.6749C19.6395 15.6749 19.6303 15.6697 19.6212 15.6645C19.3911 15.4126 19.2519 15.4422 18.3176 15.1341C17.8236 14.9376 17.3021 14.7255 16.939 14.5551C16.5922 14.3879 16.1911 14.4801 16.0192 14.7633L15.6879 15.3187C15.5763 15.5092 15.3878 15.6438 15.1711 15.7019C14.5262 15.8671 12.8372 14.4762 11.8678 13.6039C11.5924 13.3564 11.3738 13.1473 11.245 13.0135C11.1182 12.8869 10.9029 12.6616 10.6526 12.3921C9.77444 11.4265 8.38777 9.74808 8.55841 9.11339C8.60984 8.90073 8.75413 8.71672 8.94834 8.60349L9.51314 8.28389C9.80085 8.11501 9.89499 7.715 9.72713 7.37752C9.55545 7.02578 9.3451 6.50082 9.14431 6.01154C8.84323 5.09019 8.8685 4.95335 8.62053 4.72148L8.61671 4.70723C8.44949 4.54552 8.24359 4.47064 8.03748 4.51057L5.68249 5.02688C4.01022 5.49026 5.47288 10.8045 9.39233 14.7108L9.40869 14.7141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidPhone);
export default __webpack_public_path__ + "static/media/solid-phone.af593ed30c5adc9398e3bb73951ee22e.svg";
export { ForwardRef as ReactComponent };